import { Stack } from '@mui/material';
import EditableInstructionCard from './EditableInstructionCard';
import { useInstructions } from './useInstructions';
import { AiSupportInstructionProperties } from '@server/ai';
import { usePermissions } from '../../../../permissions/usePermissions';
import { useSelector } from 'react-redux';
import { selectDefaultCreationCrmOrgId } from '../../../../reducers/userInfoReducer';

interface InstructionsListProps {
  instructions: AiSupportInstructionProperties[];
  onIsPristineChange: (id: string, isPristine: boolean) => void;
}

export const InstructionsList = ({ instructions, onIsPristineChange }: InstructionsListProps) => {
  const { updateInstruction, deleteInstruction } = useInstructions();
  const crmOrgId = useSelector(selectDefaultCreationCrmOrgId) ?? '';
  const { evaluatePermissions } = usePermissions();
  const [isDeleteAllowed, isUpdateAllowed] = evaluatePermissions([
    //one permission for all actions by design
    { permission: ['create:ai-sessions', 'create:ai-sessions'], crmOrgId },
  ]);

  return (
    <Stack gap={2} pt={2}>
      {instructions?.map((instruction) => (
        <EditableInstructionCard
          key={instruction.id}
          card={instruction}
          isDeleteAllowed={isDeleteAllowed}
          isUpdateAllowed={isUpdateAllowed}
          onUpdateOrCreate={updateInstruction}
          onRemove={deleteInstruction}
          onIsPristineChange={onIsPristineChange}
        />
      ))}
    </Stack>
  );
};
